import React, { useState } from 'react';
import ky, { HTTPError } from 'ky';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button, TextField, Typography } from '@material-ui/core';

import useCurrentUserDb from '../hooks/useCurrentUserDb';
import { apiURL } from './DigimagiProvider';

type ConfirmPasswordDialogProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  actionWithConfirmation: () => void;
}
const ConfirmPasswordDialog: React.FC<ConfirmPasswordDialogProps> = ({ open, onClose, title, actionWithConfirmation }) => {
  const [userId, user] = useCurrentUserDb();
  const [value, setValue] = useState('');
  const [message, setMessage] = useState('');

  const exe = async () => {
    try {
      const sendData = {
        user_id: userId,
        username: user?.name,
        password: value
      };
      const res = await ky.post(apiURL + 'confirm_password', { json: sendData }).json() as any;
      if (res.data) {
        actionWithConfirmation();
        onClose();
      }
    } catch (err) {
      console.log(err);
      if (err instanceof HTTPError) {
        if (err.response.status === 501) setMessage('パスワードが間違っています');
        else setMessage('予期せぬエラーが発生しました。ログインし直してください。');
      }
    }
  }

  if (!userId || !user) return <></>;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl">
      <DialogTitle>{ title }</DialogTitle>
      <DialogContent style={{overflow: 'hidden'}}>
        <TextField label="現在のパスワード" variant="outlined" defaultValue={value}
          type="password" fullWidth autoFocus
          onChange={(ev) => setValue(ev.target.value)} />
        { message.length > 0 &&
          <Typography variant="caption" color="error" gutterBottom>{ message }</Typography>
        }
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={exe}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmPasswordDialog;
